/**
 * @packageDocumentation
 * @module Datetime
 */
/**
 * Function to build a datetime format
 * @param format: string with the format to analyze
 * @param showSeconds: strip out seconds from format or not
 *
 * @return string
 */
var getDatetimeFormat = function (format, showSeconds) {
    // always use two characters for hours if 12 hours format
    var result = format.replace(/\bh:/g, 'hh:');
    // if show seconds is not active, remove that from the format
    if (!showSeconds)
        result = result.replace(/:s(.*?)(s)/gi, '');
    // only leave one a for the am/pm format
    return result.replace(/( aa)\b/gi, ' a');
};
export default getDatetimeFormat;
//# sourceMappingURL=getDatetimeFormat.js.map